export default {"src":"/_next/static/media/STZ.838d392b.svg","height":18,"width":18};